@if (_routerLink) {
  <a
    routerLinkActive
    [routerLink]="_routerLink"
    [queryParams]="queryParams"
    [routerLinkActiveOptions]="routerLinkActiveOptions"
    [class.link-style]="useLinkStyle"
    (isActiveChange)="isRouterLinkActiveEmitter.emit($event)"
    [attr.aria-label]="ariaLabel"
    id="routerLink"
  >
    <ng-container *ngTemplateOutlet="content" />
  </a>
} @else {
  @if (externalLink) {
    <a
      target="_blank"
      [class.link-style]="useLinkStyle"
      [href]="externalLink"
      id="externalLink"
    >
      <ng-container *ngTemplateOutlet="content" />
    </a>
  }
}

<ng-template #content>
  <ng-content />
</ng-template>
